import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  Input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  JournalEntryAddEditComponent,
  JournalEntryAddEditComponentData,
} from '../journal-entry-add-edit/journal-entry-add-edit.component';
import {
  JournalSealAddEditComponent,
  JournalSealAddEditComponentData,
} from '../journal-seal-add-edit/journal-seal-add-edit.component';
import { PresentationalAtomsModule } from '@et/presentational/atoms';

@Component({
  selector: 'et-journal-entry-card-wrapper',
  imports: [PresentationalAtomsModule],
  templateUrl: './journal-entry-card-wrapper.component.html',
  styleUrl: './journal-entry-card-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalEntryCardWrapperComponent {
  @Input({ required: true }) isFinalized!: boolean;
  @Input({ required: true }) noEntries!: boolean;
  @Input({ required: true }) isLoading!: boolean;

  private dialog = inject(MatDialog);
  private injector = inject(Injector);

  /**
   * Opens the add eSeal dialog (draft journals).
   */
  onAddSeal() {
    this.dialog.open<
      JournalSealAddEditComponent,
      JournalSealAddEditComponentData
    >(JournalSealAddEditComponent, {
      injector: this.injector,
      panelClass: ['et-dialog-radius', 'et-dialog-padding'],
      autoFocus: false,
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
      data: {},
    });
  }

  /**
   * Opens the add cancellation act dialog.
   */
  onAddCancelAction() {
    this.dialog.open<
      JournalEntryAddEditComponent,
      JournalEntryAddEditComponentData
    >(JournalEntryAddEditComponent, {
      injector: this.injector,
      panelClass: ['et-dialog-radius', 'et-dialog-padding'],
      autoFocus: false,
      width: '100%',
      maxWidth: '800px',
      maxHeight: '90vh',
      data: {
        type: 'cancel_act',
      },
    });
  }
}
